import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import BezpieczenstwoPage from "../pages/article/bezpieczenstwo";
import DostawaPage from "../pages/article/dostawa";
import JakZaczacPage from "../pages/article/jakZaczac";
import PorownaniePage from "../pages/article/porownanie";
import NajlepszeProduktyPage from "../pages/article/najlepszeProdukty";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-poradnik",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/bezpieczenstwo-kakobuy",
    element: <BezpieczenstwoPage />,
  },
  {
    path: "/artykul/dostawa-polska",
    element: <DostawaPage />,
  },
  {
    path: "/artykul/jak-zaczac-kakobuy",
    element: <JakZaczacPage />,
  },
  {
    path: "/artykul/porownanie-agentow",
    element: <PorownaniePage />,
  },
  {
    path: "/artykul/najlepsze-produkty-2026",
    element: <NajlepszeProduktyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;